import URL from './url'
import http from '@/utils/httpUtils'

/* 第三方ISV接口授权接口文档 */
export default {
  // 查询机构下申请授权信息列表
  getAppOrgAuthApplyList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_ORG_AUTH_APPLY_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 审核接口
  authorizeAudit(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_AUTHORIZE_AUDIT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
